/**
 * Canonical design-token map for funnel block props.
 * Authors reference `token.primary` etc.; renderers resolve to CSS variables.
 */
export const FUNNEL_DESIGN_TOKENS = {
  'token.primary': 'var(--tf-primary)',
  'token.primaryHover': 'var(--tf-primary-hover)',
  'token.primaryLight': 'var(--tf-primary-light)',
  'token.primaryLighter': 'var(--tf-primary-lighter)',
  'token.secondary': 'var(--tf-secondary)',
  'token.accent': 'var(--tf-accent)',
  'token.textPrimary': 'var(--tf-text-primary)',
  'token.textSecondary': 'var(--tf-text-secondary)',
  'token.textMuted': 'var(--tf-text-muted)',
  'token.background': 'var(--tf-background)',
  'token.backgroundMuted': 'var(--tf-background-muted)',
  'token.border': 'var(--tf-border)',
  'token.success': 'var(--tf-success)',
  'token.warning': 'var(--tf-warning)',
  'token.error': 'var(--tf-error)',
} as const;

export type FunnelDesignTokenKey = keyof typeof FUNNEL_DESIGN_TOKENS;

function tokenKeyToCssVar(tokenKey: string): string {
  const suffix = tokenKey.replace(/^token\./, '');
  const kebab = suffix.replace(/([A-Z])/g, '-$1').toLowerCase();
  return `var(--tf-${kebab})`;
}

/** Resolve a block color prop — token reference, CSS var, or literal passthrough. */
export function resolveTokenColor(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) return trimmed;

  if (trimmed in FUNNEL_DESIGN_TOKENS) {
    return FUNNEL_DESIGN_TOKENS[trimmed as FunnelDesignTokenKey];
  }
  if (trimmed.startsWith('token.')) {
    return tokenKeyToCssVar(trimmed);
  }
  return trimmed;
}
